
import { RevIllustration } from '@ds/components/Illustration'

export default {
  components: {
    RevIllustration,
  },
  props: {
    banner: {
      type: Object,
      default: () => ({}),
    },
    summary: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
  },

  computed: {
    image() {
      return this.banner.retina || this.banner.image
    },
  },
}
